import { request } from './request';
import * as PATHS from '@/constants/path';
import { URLParamBuilder } from '@/utils/functions';

export function fetchProductGroups() {
  const url = URLParamBuilder(PATHS.FETCH_PRODUCT_GROUPS)
  return request(url, {
    method: 'GET'
  });
}

export function createProductGroupRequest({
  data = {}
}) {
  return request(PATHS.CREATE_PRODUCT_GROUP, {
    method: 'POST',
    data
  });
}

export function editProductGroupRequest({
  params,
  data = {}
}) {
  const finalUrl = URLParamBuilder(PATHS.EDIT_PRODUCT_GROUP, {
    params
  })
  return request(finalUrl, {
    method: 'PUT',
    data
  });
}

export function deleteProductGroupRequest({
  params = {}
}) {
  return request(URLParamBuilder(PATHS.DELETE_PRODUCT_GROUP, {
    params
  }), {
    method: 'DELETE'
  });
}

export function deleteProductGroupThumbnailRequest({
  params = {}
}) {
  return request(URLParamBuilder(PATHS.UPLOAD_THUMBNAIL_FOR_PRODUCT_GROUP, {
    params
  }), {
    method: 'DELETE'
  });
}
